import Bowser from 'bowser'

export default {
  computed: {
    $isMobile () {
      return (Bowser.getParser(window.navigator.userAgent).getResult().platform.type === 'mobile')
    },
    $isResponsive () {
      return !!(window.screen.width <= 699)
    },
    $isDesktop () {
      return !this.$isResponsive()
    },
    $platform () {
      return Bowser.getParser(window.navigator.userAgent).getResult()
    },
    $isCordova () {
      return typeof cordova !== 'undefined'
    }
  },
  methods: {
    $swalModal (...props) {
      this.$scrollUp()
      this.$swal(...props)
    },
    $scrollUp () {
      window.scrollTo(0, 0)
    }
  },
}
